<template>
  <nav>
    <h3 class="a11y-hidden">서브 메뉴 네비게이션</h3>
    <ul class="sub-list">
      <li v-for="(subMenu, index) in menuList" :key="'subMenu_' + index">
        <a href="#" :class="selectedItemClass(subMenu)" @click.prevent="()=>clickSubMenu(subMenu)">{{subMenu.title}}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
import { get } from 'lodash'
export default {
  name: 'MyPooqSubMenu',
  data () {
    return {
      subMenuList: {
        'history': [ // 이용내역
          { title: 'VOD', name: 'use_list_vod_history' },
          { title: '영화', name: 'use_list_movie_history' }
        ],
        'voucher': [ // 구매콘텐츠
          { title: '개별구매', name: 'voucher_list_singular' },
          { title: '패키지', name: 'voucher_list_package' }
        ],
        'coin_coupon': [
          { title: '코인내역', name: 'coin' },
          { title: '보유쿠폰', name: 'coupon' }
        ]
      }
    }
  },
  methods: {
    clickSubMenu (subMenu) {
      this.$router.push({ name: get(subMenu, 'name', '') })
    },
    selectedItemClass (subMenu) {
      return get(subMenu, 'name', '') === get(this.$route, 'name', '') ? 'on' : ''
    }
  },
  computed: {
    menuList () {
      const metaMenu = get(this.$route, 'meta.menu', '')
      return get(this.subMenuList, metaMenu, [])
    }
  }
}
</script>

<style scoped>
  .sub-list li.sub-like-channel {
    margin: 0 auto
  }
</style>
